<div *ngIf="!commonLoading">
  <crm-subproject-defaults-form
    [subprojectDefaults]="subprojectDefaults"
    [directions]="directions"
    [userGroups]="userGroups"
    [clients]="clients"
    (changeDefaults)="changeDefaults($event)"></crm-subproject-defaults-form>
  <div class="flex justify-content-end">
    <button
      pButton
      label="Отмена"
      [disabled]="loading"
      class="p-button-text"
      (click)="ref.close()"></button>
    <button
      pButton
      label="Заполнить"
      [disabled]="loading"
      class="p-button-success"
      (click)="ref.close(parentId)"></button>
  </div>
</div>

<crm-spinner *ngIf="commonLoading"></crm-spinner>
